"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseTel = exports.PHONE_NUMBER_TYPES = exports.COUNTRY_CALLING_CODES = void 0; // TYPES

__exportStar(require("./types"), exports); // CONSTANTS


var countryCallingCodes_1 = require("./constants/countryCallingCodes");

Object.defineProperty(exports, "COUNTRY_CALLING_CODES", {
  enumerable: true,
  get: function get() {
    return countryCallingCodes_1.COUNTRY_CALLING_CODES;
  }
});

var phoneNumberTypes_1 = require("./constants/phoneNumberTypes");

Object.defineProperty(exports, "PHONE_NUMBER_TYPES", {
  enumerable: true,
  get: function get() {
    return phoneNumberTypes_1.PHONE_NUMBER_TYPES;
  }
}); // PARSERS

var parseTel_1 = require("./parsing/parseTel");

Object.defineProperty(exports, "parseTel", {
  enumerable: true,
  get: function get() {
    return parseTel_1.parseTel;
  }
});